if(!customElements.get('fixx-motion')){
 customElements.define('fixx-motion',class extends HTMLElement{
  connectedCallback(){
   if(this.connected)return;
   this.connected=true;
   this.video=this.querySelector('video');
   this.button=this.querySelector('.fixx-motion__toggle');
   if(!this.video||!this.button)return;
   this.abort=new AbortController();
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.mobile=matchMedia('(max-width: 749px)');
   this.userPaused=false;
   this.explicitPlay=false;
   this.visible=false;
   this.video.muted=true;
   this.button.hidden=false;
   this.button.addEventListener('click',()=>{
    if(this.video.paused){this.userPaused=false;this.explicitPlay=true;this.play();}
    else{this.userPaused=true;this.video.pause();}
   },{signal:this.abort.signal});
   this.video.addEventListener('playing',()=>{this.classList.add('is-playing');this.sync();},{signal:this.abort.signal});
   this.video.addEventListener('pause',()=>this.sync(),{signal:this.abort.signal});
   this.video.addEventListener('error',()=>{this.classList.remove('is-playing');this.sync();},{signal:this.abort.signal});
   this.reduced.addEventListener('change',()=>{this.explicitPlay=false;if(this.reduced.matches)this.classList.remove('is-playing');this.update();},{signal:this.abort.signal});
   this.mobile.addEventListener('change',()=>{this.classList.remove('is-playing');this.update();},{signal:this.abort.signal});
   document.addEventListener('visibilitychange',()=>this.update(),{signal:this.abort.signal});
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.update();},{threshold:0.08});
   this.observer.observe(this);
   this.sync();
  }
  canRun(){return this.visible&&!document.hidden&&!this.userPaused&&(this.explicitPlay||(!this.reduced.matches&&!navigator.connection?.saveData));}
  update(){if(this.canRun())this.play();else this.video.pause();this.sync();}
  async play(){
   const src=this.mobile.matches?this.dataset.mobileSrc:this.dataset.desktopSrc;
   if(!src)return;
   if(this.video.getAttribute('src')!==src){this.video.src=src;this.video.load();}
   this.video.muted=true;
   try{await this.video.play();}catch{this.sync();}
  }
  sync(){this.button.textContent=this.video.paused?this.dataset.playLabel:this.dataset.pauseLabel;}
  disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();this.video?.pause();this.connected=false;}
 });
}
